<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <div class="min-h-screen pb-16 bg-gray-50/40">
        <!-- Page header -->
        <section class="pt-28">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="max-w-2xl mx-auto text-center">
              <span
                class="inline-flex items-center gap-2 px-3 py-1 mb-3 text-xs font-semibold tracking-wide uppercase rounded-full text-primary bg-primary/10"
              >
                <span
                  class="inline-block w-1.5 h-1.5 rounded-full bg-primary"
                ></span>
                Profil
              </span>
              <h1
                class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl font-roboto-slab"
              >
                Sekretariat
              </h1>
              <p class="mt-4 text-base leading-relaxed text-gray-500">
                Sekretariat Dewan Pengawas Badan Layanan Umum.
              </p>
            </div>
          </div>
        </section>

        <!-- Content card -->
        <section class="mt-12">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div
              class="overflow-hidden bg-white border border-gray-100 shadow-sm rounded-2xl"
            >
              <div class="grid grid-cols-1 lg:grid-cols-2">
                <!-- Image -->
                <div class="relative min-h-[260px] lg:min-h-full bg-gray-100">
                  <img
                    :src="`/storage/images/BGUNG.png`"
                    alt="Universitas Negeri Gorontalo"
                    class="absolute inset-0 object-cover w-full h-full"
                  />
                </div>

                <!-- Info -->
                <div class="p-6 sm:p-10">
                  <h2
                    class="text-xl font-bold leading-snug text-gray-900 sm:text-2xl font-roboto-slab"
                  >
                    Sekretariat Dewan Pengawas Badan Layanan Umum Universitas
                    Negeri Gorontalo
                  </h2>

                  <div class="mt-6 space-y-4">
                    <div class="flex items-start gap-3">
                      <span
                        class="flex items-center justify-center w-10 h-10 rounded-xl shrink-0 bg-primary/10 text-primary"
                      >
                        <i class="fa-solid fa-location-dot"></i>
                      </span>
                      <div>
                        <p class="text-sm font-semibold text-gray-900">
                          Alamat
                        </p>
                        <p class="mt-1 text-sm leading-relaxed text-gray-600">
                          Kampus I Universitas Negeri Gorontalo, Jl. Jend.
                          Sudirman No. 6, Kota Gorontalo, Provinsi Gorontalo,
                          Indonesia
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import { defineProps } from "vue";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";

defineProps({
  formasi: {
    type: Object,
    required: true,
  },
});
</script>
